import { createSelector } from 'reselect';
import { getState } from 'store/utils';

export const getLoadingScriptStore = createSelector(getState, (state) => state.loadingScript);

export const getSQLScript = createSelector(getLoadingScriptStore, (state) => state.SQLScript);
export const getSourceTables = createSelector(getLoadingScriptStore, (state) => state.sourceTables);
